itsoftApp.createModule("clipboard", function () {
    itsoftApp.loadScript("/assets/scripts/clipboard.min.js", function () {
        const copyButton = document.querySelector(".js-copy-button");
        const link = document.querySelector(".js-copy-link-text");

        if (link) {
            const linkText = link.textContent;
            let newClipboard = new ClipboardJS('.js-copy-button');
            // const tooltipMini = document.querySelector('.js-copy-tooltip');

            newClipboard.on('success', function(e) {
                e.clearSelection();
                link.textContent = "Скопировано в буфер обмена";
                copyButton.classList.add("js-copied");

                setTimeout(() => {
                    copyButton.classList.remove('js-copied');
                    link.textContent = linkText;
                }, 2000);
            });
        }
    });
});
